import React from 'react';
import {
  Heading1,
  Heading2,
  List,
  Paragraph,
} from '../components/typography';
import { Container, Row, Col } from '../components/grid';
import RowProductView from '../components/grid/RowProductView';
import ProductView1 from '../components/commerce/ProductViews/ProductView1';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';
import {
  ItemTraverser,
} from '../containers/commerce';

export default () => (
  <SidemenuLayout menuPicker="VandSodavand" activeSidemenu="Antons">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Antons økologisk saft</Heading1>
          <Heading2>Ren nydelse, økologisk forsvarlighed</Heading2>
          <Paragraph>
            Antons Økologisk Saft repræsenterer en perfekt sammensmeltning af traditionel kvalitet og innovativ tankegang, alt sammen med en urokkelig forpligtelse til fremragende smag. Hver flaske afspejler en dyb respekt for både forbrugerens helbred og miljøet, helt fri for skadelige sprøjtemidler, i tråd med strenge økologiske principper.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <RowProductView>
        <ItemTraverser category="antons" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Sølyst Gården: En historisk vugge af kvalitet</Heading2>
          <Paragraph>
            Beliggende en kilometer fra kysten i Sønderby, Juelsminde, står Sølyst Gården, Antons historiske familielandbrug siden 1857. Da Anton overtog Sølyst i 1973, forvandlede han det til et epicenter for biodynamisk landbrug. Inspireret af Rudolf Steiner&apos;s filosofi, handler det for Anton om at se jorden som en levende organisme i konstant udvikling, en tilgang han tilgår som en pragmatisk biodynamiker.
          </Paragraph>
          <Heading2>Solbærplantagen: En saga om smag</Heading2>
          <Paragraph>
            I 1981 begyndte Anton at skabe en økologisk og biodynamisk solbærplantage. Med over 115.000 solbærbuske plantet i 80&apos;erne, er Antons solbær nøje udvalgt for deres enestående smag og høje C-vitaminindhold. Jordarealet på Sølyst er nu en harmonisk blanding af solbærplantage, Ølands vårhvede, kløvergræs, naturareal og fredskov. Anton anvender banebrydende metoder som udsætning af humlebier, oprettelse af insekthoteller og fuglekasser, for at skabe et bæredygtigt økosystem.
          </Paragraph>
          <Heading2>
            Kerneværdierne bag hver dråbe saft
          </Heading2>
          <List>
            <li>Omfattende kendskab til forskellige frugt- og bærsorter sikrer exceptionel smag og kvalitet i Antons saft.</li>
            <li>Streng smagsprøveproces sikrer kun de bedste råvarer anvendes.</li>
            <li>Kompromisløs brug af udelukkende økologiske eller biodynamiske råvarer.</li>
            <li>Rent vand, der er sikkert nok til selv de yngste, bruges i saftproduktionen.</li>
            <li>Antons landbrugspraksis skåner 14,4 millioner liter grundvand mod forurening af sprøjtegifte.</li>
          </List>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
